import React, { useEffect, useState } from 'react';
import axios from "axios";

function AddMoney() {
  const [error, setError] = useState("");
  const [amount, setAmount] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());
  const [paymentType, setPaymentType] = useState("prepaid"); // Prepaid by default
  const [employeesData, setEmployeesData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // Postpaid-specific fields
  const [limit, setLimit] = useState("");
  const [restaurantName, setRestaurantName] = useState("");

  const professionalUserId = localStorage.getItem("professionalUserId");
  const authToken = localStorage.getItem("authToken");

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedIds([]);
    } else {
      setSelectedIds(employeesData.map(emp => emp.userId));
    }
    setSelectAll(!selectAll);
  };

  const handleSelectRow = (id) => {
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(uid => uid !== id) : [...prev, id]
    );
  };

  // Prepaid payment
  const handleSendPrepaid = async () => {
    if (!amount || !month || !selectedIds.length) {
      alert("Please enter amount, select month and employees.");
      return;
    }

    if (!professionalUserId || !authToken) {
      alert("Professional User ID or Auth Token missing. Please login again.");
      return;
    }

    try {
      const apiUrl = `https://backend.maamaas.com/subscription/api/walletmoney/add/transfer`;

      for (const empId of selectedIds) {
        const employee = employeesData.find(emp => emp.userId === empId);
        if (!employee) continue;

        const url = `${apiUrl}?professionalUserId=${professionalUserId}&phoneNumber=${employee.phoneNumber}&amount=${amount}&month=${month.toUpperCase()}&year=${year}`;

        await axios.post(url, null, {
          headers: {
            "Authorization": `Bearer ${authToken}`,
            "accept": "*/*",
          },
        });

        console.log(`Prepaid payment successful for ${employee.name}`);
      }

      alert("Prepaid payment successful ✅ for all selected employees");

      setAmount("");
      setMonth("");
      setSelectedIds([]);
      setSelectAll(false);

    } catch (error) {
      console.error("Prepaid Payment failed:", error.response || error.message);
      alert(
        "Prepaid Payment failed ❌" +
        (error.response?.data?.error ? `: ${error.response.data.error}` : "")
      );
    }
  };

  // Postpaid payment
  const handleSendPostpaid = async () => {
    if (!amount || !month || !year || !limit || !restaurantName || !selectedIds.length) {
      alert("Please fill all fields for Postpaid.");
      return;
    }

    if (!professionalUserId || !authToken) {
      alert("Professional User ID or Auth Token missing. Please login again.");
      return;
    }

    try {
      const apiUrl = `https://backend.maamaas.com/subscription/api/walletmoney/postpaid/approval`;

      for (const empId of selectedIds) {
        const employee = employeesData.find(emp => emp.userId === empId);
        if (!employee) continue;

        const url = `${apiUrl}?professionalUserId=${professionalUserId}&phoneNumber=${employee.phoneNumber}&amount=${amount}&month=${month.toUpperCase()}&year=${year}&limit=${limit}&restaurentname=${restaurantName}&postpaid=true`;

        await axios.post(url, null, {
          headers: {
            "Authorization": `Bearer ${authToken}`,
            "accept": "*/*"
          }
        });

        console.log(`Postpaid payment successful for ${employee.name}`);
      }

      alert("Postpaid payment successful ✅");

      // Reset fields
      setAmount("");
      setMonth("");
      setYear(new Date().getFullYear());
      setLimit("");
      setRestaurantName("");
      setSelectedIds([]);
      setSelectAll(false);

    } catch (error) {
      console.error("Postpaid Payment failed:", error.response || error.message);
      alert(
        "Postpaid Payment failed ❌" +
        (error.response?.data?.error ? `: ${error.response.data.error}` : "")
      );
    }
  };

  // Fetch employees
  useEffect(() => {
    const fetchEmployees = async () => {
      if (!professionalUserId || !authToken) {
        setError("Professional User ID or Auth Token missing.");
        return;
      }

      try {
        const apiUrl = `https://backend.maamaas.com/subscription/api/wallet/employees?professionalUserId=${professionalUserId}`;
        const response = await axios.get(apiUrl, {
          headers: { "Authorization": `Bearer ${authToken}` },
        });

        if (Array.isArray(response.data)) {
          setEmployeesData(response.data);
        } else if (response.data?.employees) {
          setEmployeesData(response.data.employees);
        } else {
          setEmployeesData([]);
        }
      } catch (err) {
        console.error("Fetch Employees Error:", err);
        setError("Error fetching employees");
        setEmployeesData([]);
      }
    };
    fetchEmployees();
  }, [authToken, professionalUserId]);

  return (
    <div>
      <h3>Wallet Payment</h3>
      {/* Input Section */}
      <div style={{ marginBottom: "15px", display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>

        <select value={month} onChange={(e) => setMonth(e.target.value)} style={{ padding: "5px" }}>
          <option value="">Select Month</option>
          {[
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
          ].map(m => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>

        <input
          type="number"
          placeholder="Year"
          value={year}
          onChange={(e) => setYear(e.target.value)}
          style={{ padding: "5px", border: "1px solid #ccc" }}
        />

        <select value={paymentType} onChange={(e) => setPaymentType(e.target.value)} style={{ padding: "5px" }}>
          <option value="prepaid">Prepaid</option>
          <option value="postpaid">Postpaid</option>
        </select>
        {paymentType === "prepaid" && (
          <input
            type="number"
            placeholder="Enter Amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            style={{ padding: "5px", border: "1px solid #ccc" }}
          />
        )}
        {/* Conditional Postpaid Fields */}
        {paymentType === "postpaid" && (
          <>
            <input
              type="number"
              placeholder="Limit"
              value={limit}
              onChange={(e) => setLimit(e.target.value)}
              style={{ padding: "5px", border: "1px solid #ccc" }}
            />
            <input
              type="text"
              placeholder="Restaurant Name"
              value={restaurantName}
              onChange={(e) => setRestaurantName(e.target.value)}
              style={{ padding: "5px", border: "1px solid #ccc" }}
            />
          </>
        )}

        {/* Send Button */}
        {paymentType === "prepaid" ? (
          <button onClick={handleSendPrepaid} style={{ background: "#b15cd6", color: "#fff", padding: "6px 15px", border: "none", borderRadius: "5px" }}>
            Send Prepaid
          </button>
        ) : (
          <button onClick={handleSendPostpaid} style={{ background: "#4caf50", color: "#fff", padding: "6px 15px", border: "none", borderRadius: "5px" }}>
            Send Postpaid
          </button>
        )}
      </div>

      {/* Employees Table */}
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={tableHeaderStyle}><input type="checkbox" checked={selectAll} onChange={handleSelectAll} /></th>
            <th style={tableHeaderStyle}>S.No</th>
            <th style={tableHeaderStyle}>Name</th>
            <th style={tableHeaderStyle}>Email</th>
            <th style={tableHeaderStyle}>Phone</th>
            <th style={tableHeaderStyle}>Employee ID</th>
            <th style={tableHeaderStyle}>App User ID</th>
          </tr>
        </thead>
        <tbody>
          {employeesData.map((item, index) => (
            <tr key={item.id || index}>
              <td style={tableCellStyle}>
                <input
                  type="checkbox"
                  checked={selectedIds.includes(item.userId)}
                  onChange={() => handleSelectRow(item.userId)}
                />
              </td>
              <td style={tableCellStyle}>{index + 1}</td>
              <td style={tableCellStyle}>{item.name}</td>
              <td style={tableCellStyle}>{item.email}</td>
              <td style={tableCellStyle}>{item.phoneNumber}</td>
              <td style={tableCellStyle}>{item.empid}</td>
              <td style={tableCellStyle}>{item.userId}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
}

// Styles
const tableStyle = { width: "100%", borderCollapse: "collapse", marginTop: "10px" };
const tableHeaderStyle = { border: "1px solid #ddd", padding: "8px", backgroundColor: "#b15cd6", color: "white", textAlign: "center" };
const tableCellStyle = { border: "1px solid #ddd", padding: "6px", textAlign: "center" };

export default AddMoney;
